import { CampaignStatus, CampaignStatusLabels } from '@monitoring-panel/types';
import { cn } from '@/lib/utils';
import { EXECUTION_STATUS_TAG } from '@/lib/advia-status';

interface StatusBadgeProps {
  status: CampaignStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'adv-tag',
        EXECUTION_STATUS_TAG[status],
        className
      )}
    >
      {status}. {CampaignStatusLabels[status]}
    </span>
  );
}
